import { render, staticRenderFns } from "./RevenueExpenseChart.vue?vue&type=template&id=2236e8e8&scoped=true&"
import script from "./RevenueExpenseChart.vue?vue&type=script&lang=js&"
export * from "./RevenueExpenseChart.vue?vue&type=script&lang=js&"
import style0 from "./RevenueExpenseChart.vue?vue&type=style&index=0&id=2236e8e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2236e8e8",
  null
  
)

export default component.exports